module.exports = __webpack_public_path__ + "img/small-logo.0b75de0.svg";